import { useState } from "react";
import { Card, Modal, Select, Typography } from "antd";
import ModalDelete from "components/ModalDelete";
import useCreate from "hooks/useCreate";
import { useWorkers } from "context/providers/workers";
import WorkerAvatar from "../WorkerAvatar";

const AssignWorker = ({ data, refetch }) => {
  const [is_open, setOpen] = useState(null);
  const [worker_id, setWorkerId] = useState(null);

  const { workers, workers_list_options } = useWorkers();

  const { is_saving: is_saving_unassign, create: unassignWorker } = useCreate({
    path: `/issues/${data?.id}/unassign_from_worker`,
    onSuccess: refetch,
    success_message: "Zgłoszenie zostałe odpisane od pracownika",
  });

  const { is_saving: is_saving_assign, create: assignWorker } = useCreate({
    path: `/issues/${data?.id}/assign_to_worker`,
    onSuccess: refetch,
    success_message: "Zgłoszenie zostałe przypisane do pracownika",
  });

  const is_ready = [undefined, "completed", "cancelled"].includes(data?.status);

  return (
    <Card
      style={{ marginBottom: 24 }}
      title="Pracownik"
      extra={
        !is_ready && data?.worker?.id ? (
          <ModalDelete
            only_icon={true}
            text="przypisanie pracownika"
            handleDelete={unassignWorker}
          />
        ) : null
      }
    >
      {is_open && (
        <Modal
          style={{ top: 45 }}
          title="Potwierdzenie"
          open={is_open}
          onOk={() => {
            assignWorker({ worker_id });
            setWorkerId(null);
            setOpen(false);
          }}
          onCancel={() => {
            setWorkerId(null);
            setOpen(false);
          }}
          cancelText="Anuluj"
          okText="Potwierdzam"
        >
          Czy chcesz przypisać pracownika (
          {workers.find(({ id }) => id === worker_id)?.full_name}) do
          zgłoszenia?
        </Modal>
      )}
      {is_ready ? (
        data?.worker?.id ? (
          <WorkerAvatar worker={data.worker} assigned_at={data.assigned_at} />
        ) : (
          <Typography.Text>Brak</Typography.Text>
        )
      ) : data?.worker?.id ? (
        <WorkerAvatar worker={data.worker} assigned_at={data.assigned_at} />
      ) : (
        <Select
          style={{ minWidth: "200px" }}
          size="large"
          loading={is_saving_assign || is_saving_unassign}
          placeholder="Wybierz pracownika"
          optionFilterProp="children"
          onChange={(val) => {
            setWorkerId(val);
            setOpen(true);
          }}
          options={workers_list_options || []}
        />
      )}
    </Card>
  );
};

export default AssignWorker;
